import { useAuth0 } from "@auth0/auth0-react";
import { useState, useEffect, useContext } from 'react'
import { getExportData } from '../utilities/general-utils'
import TransactionItems from '../components/TransactionItem/TransactionItems'
import LoadingSpinner from '../components/ui/LoadingSpinner'
import ReportingWrapper from '../components/reporting/ReportingWrapper'
import FiltersHeader from '../components/FiltersHeader/FiltersHeader'
import { InputVarsContext } from '../contexts/input-vars-context'
import '../components/FiltersHeader/FiltersHeader.scss'
import { IconAngleDownBold, IconAngleUpBold } from '../assets/icons';
import AddTransactionsPrompt from "../components/Prompts/AddTransactionsPrompt";
import AddAccountsPrompt from "../components/Prompts/AddAccountsPrompt";
import { TransactionDisplayContext } from "../contexts/transaction-display-context";
import { svc_getDashboardData } from '../services/dashboard.service';

// need a 'preferences' table to store values like this
const lsKeyReporting = 'hideReporting'

const Dashboard = () => {
    const { vars } = useContext(InputVarsContext)
    const { getAccessTokenSilently, user } = useAuth0();
    const [isLoading, setIsLoading] = useState(false)
    const [dashboardData, setDashboardData] = useState(null)
    const [exportData, setExportData] = useState(null)
    const [hideReporting, setHideReporting] = useState(localStorage.getItem(lsKeyReporting) === 'true')
    const [filtersVisible, setFiltersVisible] = useState(false);
    const { transactionDisplaySettings, setTransactionDisplaySettings } = useContext(TransactionDisplayContext)

    const resetData = async () => {
        setExportData(null)
        setDashboardData(null)
    }

    const loadDashboardData = async () => {
        try {
            setIsLoading(true)
            const accessToken = await getAccessTokenSilently();
            const data = await svc_getDashboardData(
                accessToken, 
                user.sub, 
                vars.dateRange.startDate, 
                vars.dateRange.endDate, 
                !hideReporting
            );
            
            setDashboardData(data);
            
            if (data.transactions) {
                setExportData(getExportData(data.transactions));
            }
        } catch (error) {
            console.error("Error loading dashboard data:", error);
        } finally {
            setIsLoading(false)
        }
    };

    const handleToggle = () => {
        setFiltersVisible(!filtersVisible);
    };

    useEffect(() => {
        if (vars.dateRange.startDate && vars.dateRange.endDate && !dashboardData && !isLoading) {
            loadDashboardData()
        }
    }, [
        vars.dateRange.startDate,
        vars.dateRange.endDate,
        hideReporting
    ])

    useEffect(() => {
        if (transactionDisplaySettings.hideExceptionLinkToTransactions) {
            setTransactionDisplaySettings({
                ...transactionDisplaySettings,
                hideExceptionLinkToTransactions: false
            })
        }
    }, [transactionDisplaySettings.hideExceptionLinkToTransactions])

    return dashboardData?.showOnboardingMessage ? ( <OnBoardingMessage /> ) : (
        <div>
            <div className={`standardFormWrap forecast-filters ${filtersVisible ? 'filters-visible' : ''}`}>
                <FiltersHeader
                    isLoading={isLoading}
                    onStartDateChange={resetData}
                    onEndDateChange={resetData}
                />
                <ReportVisibilityToggler
                    setHideReporting={setHideReporting}
                />
                <button
                    className={`forecast-filters__btn-toggle button-unstyled`}
                    onClick={handleToggle}
                >
                    {filtersVisible ? <IconAngleUpBold fill="#fff" /> : <span style={{fontSize: '1.4rem', color: "#fff"}}>$<br /><IconAngleDownBold fill="#fff" /></span>}
                </button>
            </div>

            <h1 className="text-center">Dashboard</h1>

            {!vars || isLoading ? (
                <LoadingSpinner />
            ) : (
                <>
                    {!hideReporting && dashboardData?.reportingData && (
                        <ReportingWrapper
                            minMaxData={dashboardData.reportingData.minMaxData}
                            netIncomeData={dashboardData.reportingData.netIncomeData}
                        />
                    )}
        
                    {dashboardData?.transactions && (
                        <TransactionItems
                            title="Upcoming Transactions"
                            items={dashboardData.transactions}
                            exportData={exportData}
                        />
                    )}
                </>
            )}
        </div>
    )
}

const OnBoardingMessage = () => {
    return (
        <div className="text-center spc-p-b-2">
            <h1>Something's missing...</h1>

            <p>
                Your budget forecast <span style={{fontStyle: 'italic'}}>would</span> be here, but it looks like we need a little more information.
            </p>

            <div style={{backgroundColor: "#fff", padding: "1rem 1rem 3rem", marginTop: "3rem"}}>
                <AddAccountsPrompt className="spc-m-b-2" />
                <AddTransactionsPrompt />
            </div>
        </div>
    )
}

const ReportVisibilityToggler = ({ setHideReporting }) => {
    return (
        <div className="formField formField-inline-checkbox dis-inline-flex size-w-auto">
            <input
                id="hideReporting"
                type="checkbox"
                defaultChecked={localStorage.getItem(lsKeyReporting) === 'true'}
                onChange={(e) => {
                    localStorage.setItem(lsKeyReporting, e.target.checked)
                    setHideReporting(
                        e.target.checked ? true : false
                    )
                }}
            />
            <label htmlFor="hideReporting">Hide Reporting</label>
        </div>
    )
}

export default Dashboard
